import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalLoaderComponent } from './global-loader.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [GlobalLoaderComponent],
  exports: [GlobalLoaderComponent],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class GlobalLoaderModule {
}
